export default __webpack_public_path__ + "static/media/plbgcircle2.d3378973.png";